var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"mx-auto md:w-2/5 lg:w-2/4 mt-10"},_vm._l((_vm.linksList),function(link){return _c('Link',{key:link.title,attrs:{"link":link,"href":link.link}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }